<template>
    <div style="margin-left: 40px; margin-right: 40px;">
      <el-tabs v-model="qdtab">
        <el-tab-pane label="年卡" name="mcard">
          <el-col :span="24">
            <el-col :span="12"><div class="queryinput" style="margin-top: 5px;">
              <el-input v-model="m_tcardnum" placeholder="请输入生成年卡数量"></el-input>
            </div></el-col>
            <div class="queryinput" style="padding-left: 0px">
              <el-button @click="m_maketcard" style="margin-top: 5px;">生成卡</el-button>
              <el-button @click="m_querytcard" style="margin-top: 5px;">查询次卡</el-button>
              <el-button @click="m_exportexcel" style="margin-top: 5px;">导出Excel</el-button>
            </div>
          </el-col>
          <el-table
            id="m_tcarddataid"
            :data="m_tcarddata"
            fit>
            <el-table-column
              prop="tcardno"
              label="卡号"
            >
            </el-table-column>
            <el-table-column
              prop="tcardpwd"
              label="卡密"
            >
            </el-table-column>
            <el-table-column
              prop="state"
              label="状态"
            >
            </el-table-column>
            <el-table-column
              fixed="right"
              label="操作"
              class-name="outopicondiv"
            >
              <template slot-scope="scope">
                <div class="inopicondiv">
                  <i class="fa fa-trash-o opicon curpointer" v-on:click="m_removetcard(scope.$index, m_tcarddata)"> 删除 </i>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="季卡" name="jcard">
          <el-col :span="24">
            <el-col :span="12"><div class="queryinput" style="margin-top: 5px;">
              <el-input v-model="j_tcardnum" placeholder="请输入生成季卡数量"></el-input>
            </div></el-col>
            <div class="queryinput" style="padding-left: 0px">
              <el-button @click="j_maketcard" style="margin-top: 5px;">生成卡</el-button>
              <el-button @click="j_querytcard" style="margin-top: 5px;">查询次卡</el-button>
              <el-button @click="j_exportexcel" style="margin-top: 5px;">导出Excel</el-button>
            </div>
          </el-col>
          <el-table
            id="j_tcarddataid"
            :data="j_tcarddata"
            fit>
            <el-table-column
              prop="tcardno"
              label="卡号"
            >
            </el-table-column>
            <el-table-column
              prop="tcardpwd"
              label="卡密"
            >
            </el-table-column>
            <el-table-column
              prop="state"
              label="状态"
            >
            </el-table-column>
            <el-table-column
              fixed="right"
              label="操作"
              class-name="outopicondiv"
            >
              <template slot-scope="scope">
                <div class="inopicondiv">
                  <i class="fa fa-trash-o opicon curpointer" v-on:click="j_removetcard(scope.$index, j_tcarddata)"> 删除 </i>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="双年卡" name="ycard">
          <el-col :span="24">
            <el-col :span="12"><div class="queryinput" style="margin-top: 5px;">
              <el-input v-model="y_tcardnum" placeholder="请输入生成双年卡数量"></el-input>
            </div></el-col>
            <div class="queryinput" style="padding-left: 0px">
              <el-button @click="y_maketcard" style="margin-top: 5px;">生成卡</el-button>
              <el-button @click="y_querytcard" style="margin-top: 5px;">查询次卡</el-button>
              <el-button @click="y_exportexcel" style="margin-top: 5px;">导出Excel</el-button>
            </div>
            <el-table
              id="y_tcarddataid"
              :data="y_tcarddata"
              fit>
              <el-table-column
                prop="tcardno"
                label="卡号"
              >
              </el-table-column>
              <el-table-column
                prop="tcardpwd"
                label="卡密"
              >
              </el-table-column>
              <el-table-column
                prop="state"
                label="状态"
              >
              </el-table-column>
              <el-table-column
                fixed="right"
                label="操作"
                class-name="outopicondiv"
              >
                <template slot-scope="scope">
                  <div class="inopicondiv">
                    <i class="fa fa-trash-o opicon curpointer" v-on:click="y_removetcard(scope.$index, y_tcarddata)"> 删除 </i>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-tab-pane>
      </el-tabs>
</div>
</template>

<script>
  import XLSX from 'xlsx'
  var that
  export default {
    name: 'TCard',
    data () {
      return {
        qdtab: 'mcard',
        m_tcarddata: [],
        m_tcardnum: 2000,
        j_tcarddata: [],
        j_tcardnum: 2000,
        y_tcarddata: [],
        y_tcardnum: 2000,
        khid: ''
      }
    },
    mounted () {
      that = this
      var v = getCookie('cusid')
      this.khid = v
    },
    methods: {
      RondomPass: function (number) {
        var arr = []
        var arr1 = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9']
        for (var i = 0; i < number; i++) {
          var n = Math.floor(Math.random() * 10)
          arr[i] = arr1[n]
        }
        var valinfo = arr.join('')
        return valinfo
      },
      m_maketcard () {
        var adata = []
        for (var i = 0; i < parseInt(that.m_tcardnum); i++) {
          var rmdCard = '5' + that.RondomPass(7)
          var rmdCardPwd = that.RondomPass(6)
          var adtmp = {
              tcardno: rmdCard,
              tcardpwd: rmdCardPwd,
              cardtype: parseInt(1),
              state: parseInt(0),
              cusid: parseInt(that.khid)
          }
          adata.push(adtmp)
        }
        window.console.log(adata)

        that.$http({
          url: 'https://api.sqnetsoft.cn/order/paaubtc',
          method: 'post',
          data: adata,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.data.success) {
              that.$options.methods.m_querytcard()
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      m_querytcard () {
        var cstr = 'cusid = ' + that.khid + ' and cardtype=1'
        that.$http({
          url: 'https://api.sqnetsoft.cn/order/getbtc',
          method: 'post',
          data: {
            whereinfo: {String: cstr, Valid: true}
          },
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.data.success) {
              window.console.log(JSON.parse(res.data.data))
              that.m_tcarddata = JSON.parse(res.data.data)
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      m_exportexcel () {
        // 表名
        var ws = XLSX.utils.json_to_sheet(that.m_tcarddata);
        /* get binary string as output */
        var wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, '年次卡');
        /* 生成xlsx文件 */
        XLSX.writeFile(wb, '年次卡.xlsx');
      },
      m_removetcard (index,data) {
        var curselectdata = data[index]
        // 从数据源中查找该数据的索引
        var dataindex = this.m_tcarddata.findIndex(d => d.id === curselectdata.id)
        // 移除该条数据
        this.m_tcarddata.splice(dataindex, 1)
        var qstr = 'id=' + curselectdata.id.Int64
        // 提交到后台服务器做处理
        that.$http({
          url: 'https://api.sqnetsoft.cn/order/delbtc',
          method: 'post',
          data: {
            whereinfo: {'String': qstr, Valid: true}
          },
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            console.log(res)
            if (res.data.success) {
              that.$options.methods.m_querytcard()
              that.$message({
                type: 'success',
                message: '删除成功'
              })
            } else {
              that.$message({
                type: 'error',
                message: '删除失败'
              })
            }
          })
          .catch(function (error) {
            that.$message({
              type: 'error',
              message: '删除失败'
            })
            console.log('error' + error)
          })
      },
      j_maketcard () {
        var adata = []
        for (var i = 0; i < parseInt(that.j_tcardnum); i++) {
          var rmdCard = '6' + that.RondomPass(7)
          var rmdCardPwd = that.RondomPass(6)
          var adtmp = {
            tcardno: rmdCard,
            tcardpwd: rmdCardPwd,
            cardtype: parseInt(2),
            state: parseInt(0),
            cusid: parseInt(that.khid)
          }
          adata.push(adtmp)
        }
        window.console.log(adata)

        that.$http({
          url: 'https://api.sqnetsoft.cn/order/paaubtc',
          method: 'post',
          data: adata,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.data.success) {
              that.$options.methods.j_querytcard()
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      j_querytcard () {
        var cstr = 'cusid = ' + that.khid + ' and cardtype=2'
        that.$http({
          url: 'https://api.sqnetsoft.cn/order/getbtc',
          method: 'post',
          data: {
            whereinfo: {String: cstr, Valid: true}
          },
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.data.success) {
              window.console.log(JSON.parse(res.data.data))
              that.j_tcarddata = JSON.parse(res.data.data)
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      j_exportexcel () {
        // 表名
        var ws = XLSX.utils.json_to_sheet(that.j_tcarddata);
        /* get binary string as output */
        var wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, '季次卡');
        /* 生成xlsx文件 */
        XLSX.writeFile(wb, '季次卡.xlsx');
      },
      j_removetcard (index,data) {
        var curselectdata = data[index]
        // 从数据源中查找该数据的索引
        var dataindex = this.j_tcarddata.findIndex(d => d.id === curselectdata.id)
        // 移除该条数据
        this.j_tcarddata.splice(dataindex, 1)
        var qstr = 'id=' + curselectdata.id.Int64
        // 提交到后台服务器做处理
        that.$http({
          url: 'https://api.sqnetsoft.cn/order/delbtc',
          method: 'post',
          data: {
            whereinfo: {'String': qstr, Valid: true}
          },
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            console.log(res)
            if (res.data.success) {
              that.$options.methods.j_querytcard()
              that.$message({
                type: 'success',
                message: '删除成功'
              })
            } else {
              that.$message({
                type: 'error',
                message: '删除失败'
              })
            }
          })
          .catch(function (error) {
            that.$message({
              type: 'error',
              message: '删除失败'
            })
            console.log('error' + error)
          })
      },
      y_maketcard () {
        var adata = []
        for (var i = 0; i < parseInt(that.y_tcardnum); i++) {
          var rmdCard = '8' + that.RondomPass(7)
          var rmdCardPwd = that.RondomPass(6)
          var adtmp = {
            tcardno: rmdCard,
            tcardpwd: rmdCardPwd,
            cardtype: parseInt(3),
            state: parseInt(0),
            cusid: parseInt(that.khid)
          }
          adata.push(adtmp)
        }
        window.console.log(adata)

        that.$http({
          url: 'https://api.sqnetsoft.cn/order/paaubtc',
          method: 'post',
          data: adata,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.data.success) {
              that.$options.methods.y_querytcard()
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      y_querytcard () {
        var cstr = 'cusid = ' + that.khid + ' and cardtype=3'
        that.$http({
          url: 'https://api.sqnetsoft.cn/order/getbtc',
          method: 'post',
          data: {
            whereinfo: {String: cstr, Valid: true}
          },
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.data.success) {
              window.console.log(JSON.parse(res.data.data))
              that.y_tcarddata = JSON.parse(res.data.data)
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      y_exportexcel () {
        // 表名
        var ws = XLSX.utils.json_to_sheet(that.y_tcarddata);
        /* get binary string as output */
        var wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, '双年次卡');
        /* 生成xlsx文件 */
        XLSX.writeFile(wb, '双年次卡.xlsx');
      },
      y_removetcard (index,data) {
        var curselectdata = data[index]
        // 从数据源中查找该数据的索引
        var dataindex = this.y_tcarddata.findIndex(d => d.id === curselectdata.id)
        // 移除该条数据
        this.tcarddata.splice(dataindex, 1)
        var qstr = 'id=' + curselectdata.id.Int64
        // 提交到后台服务器做处理
        that.$http({
          url: 'https://api.sqnetsoft.cn/order/delbtc',
          method: 'post',
          data: {
            whereinfo: {'String': qstr, Valid: true}
          },
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            console.log(res)
            if (res.data.success) {
              that.$options.methods.y_querytcard()
              that.$message({
                type: 'success',
                message: '删除成功'
              })
            } else {
              that.$message({
                type: 'error',
                message: '删除失败'
              })
            }
          })
          .catch(function (error) {
            that.$message({
              type: 'error',
              message: '删除失败'
            })
            console.log('error' + error)
          })
      }
    }
  }
  function getCookie (name) {
    var v = window.document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)')
    return v ? v[2] : null
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/cardticket/TCard.vue